export const state = {
  current_invitation: null,
  invitations: [],
};
